<template>
  <div class="hello">
    <div class="headerBox">
      <HeaDers />
      <!-- 头部导航 -->
    </div>
    <router-view></router-view>
    <!-- <Foot /> -->
  </div>
</template>
<script>
import HeaDers from "./HeaDers.vue";
import Foot from "../components/Foot.vue";
// import User from "./Rotation.vue";
// import Notice from './Notice.vue'
// import Assessment from "./Assessment.vue";
export default {
  components: { HeaDers,Foot },
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      showHeader:true,
    };
  },
  created(){
    // console.log(window.location.hash)
    // const url = window.location.hash
    // if(url.includes('Inspection') || url.includes('Rotation')){
    //   this.showHeader = false
    // }else{
    //   this.showHeader = true
    // }
  }
 
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
}
html,
body {
  height: 100%;
  width: 100%;
}
div {
  width: 100%;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.BOX_DIV {
  height: 100%;
  width: 100%;
  display: flex;
}
.el-container {
  width: 100%;
  height: 100%;
}
/* .orderBox{
  height: 100vh;
} */
.headerBox {
  height: 80px;

  width: 100%;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  box-shadow:2px 3px 10px 2px rgba(0,0,0,0.1);
  -webkit-box-shadow:1px 2px 2px 1px rgba(0,0,0,0.1);
  
}
.User {
  height: 50px;
  width: 100%;
  background: rgb(0, 84, 149);
}
.Notice {
  height: 300px;
  width: 60%;
  display: flex;
  margin: 5vh auto;
}
.assessment {
  height: 300px;
  width: 65%;
  display: flex;
  margin: 5vh auto;
}
.hello {
  height: 100%;
}
</style>
